import { memo } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useInstanceSelector } from '@client/hooks/redux.hooks';
import { getCategoryById } from '@client/selectors/entities/categories';

const useStyles = makeStyles({ name: 'ProfileBadge' })((theme) => ({
  badgeContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1 / 2, 1),
    borderBottomRightRadius: theme.radii.medium,
    borderTopLeftRadius: theme.radii.large,
  },
  badgeContent: {
    color: theme.palette.text.disabled,
    userSelect: 'none',
  },
  featuredBadgeContent: {
    color: theme.palette.primary.dark,
  },
}));

interface ProfileBadgeProps {
  readonly badgeId?: string;
  readonly isFeatured?: boolean;
}

export const ProfileBadge = memo<ProfileBadgeProps>(({ isFeatured, badgeId }) => {
  const { classes, cx } = useStyles();
  const badge = useInstanceSelector(getCategoryById, badgeId);

  if (!isFeatured && !badge) {
    return null;
  }

  return (
    <div className={classes.badgeContainer}>
      <Typography
        variant="overline"
        className={cx(classes.badgeContent, isFeatured && classes.featuredBadgeContent)}
      >
        {badge ? badge.lang.label : 'Featured'}
      </Typography>
    </div>
  );
});
